import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";
import { Link } from "react-router-dom";
import ph_logo from "../../../images/IFFFI_LOGO.png";
import ph_Nfdc from "../../../images/NFDC-Logo.png";
// import IP from "../../../images/IP_Image.png"
import IP from "../../../images/peck2.jpg";
import "./forgotPassword.css";
import { useNavigate } from "react-router-dom";
import TajMahal from "../../../images/Group 706.png";

const ForgetPasswordDetails = ({
  formData,
  errors,
  handleInputChange,
  handleSubmit,
}) => {
  const navigate = useNavigate();

  const backtopreviouspage = async (e) => {
    navigate("/");
  };

  return (
    <div className="container-fluid px-0 w-100 h-100 overflow-x-hidden position-absolute">
      <div className="row h-100">
        <div className="col-sm-12 col-md-12 col-lg-6 overflow-x-hidden h-100 response-phone">
          <img
            src={IP}
            className="mob_IP"
            alt="Indian Panorama"
            width="100%"
            height="100%"
          />
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 second-box h-100 overflow-auto">
          <div className="new-div">
            <div className="logo-Phone">
              <a href={process.env.REACT_APP_HOME_URL}>
                <img
                  src={ph_logo}
                  className=""
                  alt="Indian Panorama"
                  width="85px"
                  height="auto"
                />
              </a>
              <img
                src={ph_Nfdc}
                className=""
                alt="Indian Panorama"
                width="85px"
                height="auto"
              />
            </div>
            <div className="container">
              <div className="row">
                {/* <p className='register me-3'>Don't have account?<Link to="/" className='register_now'>Previous Page</Link></p> */}
                {/* <p className='register me-3' style={{ cursor: "pointer" }}><p onClick={backtopreviouspage}><b>Go to previous page </b></p></p> */}
                <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                <div className="col-sm-10 col-md-10 col-lg-10 col-xl-10">
                  <h1 className="forget_password_details">Forget Password</h1>
                  {/* <p className='login_with_email'>Registration is simply dummy text of the printing</p> */}
                  <form encType="multipart/form-data">
                    <div className="input_field">
                      <TextField
                        variant="outlined"
                        type="email"
                        fullWidth
                        placeholder="Enter Email Address"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <EmailIcon />
                            </InputAdornment>
                          ),
                          style: {
                            border: "1px solid #1c5768",
                            borderRadius: "5px",
                          },
                        }}
                        className="forget_password_input"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        error={!!errors.email}
                        helperText={errors.email}
                      />

                      {/* {errors.email ? (
                                            <p className="error text-danger">
                                                Please provide valid email address
                                            </p>
                                        ) : null} */}

                      {/* {errors.email && <p className="error text-danger">{errors.email}</p>} */}
                    </div>
                    {/* <p className='Log_in'><Link to="/" className='back_to_log_in btn btn-success"'>Back To Log in</Link></p> */}
                    {/* <p className='Log_in'><button className="btn btn-success" onClick={backtopreviouspage}>Back</button></p> */}

                    <div className="button">
                      <button className="login" onClick={handleSubmit}>
                        Send
                      </button>
                    </div>
                    <div className="text-center mt-3">
                      <button
                        onClick={backtopreviouspage}
                        className="log_in_now"
                      >
                        Go to previous page
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
            </div>
            <div className="taj-imag2">
              <img
                src={TajMahal}
                className="tajmahal"
                alt="Tajmal image"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordDetails;
